import { useCallback } from 'react';
import Navbar from '@/pages/home/components/Navbar';
import Hero from '@/pages/home/components/Hero';
import Ticker from '@/pages/home/components/Ticker';
import RankingSection from '@/pages/home/components/RankingSection';
import CollectionsSection from '@/pages/home/components/CollectionsSection';
import LatestSection from '@/pages/home/components/LatestSection';
import StatsSection from '@/pages/home/components/StatsSection';
import DigSection from '@/pages/home/components/DigSection';
import TimelineSection from '@/pages/home/components/TimelineSection';
import SubscribeSection from '@/pages/home/components/SubscribeSection';
import Footer from '@/pages/home/components/Footer';
import { useReveal } from '@/hooks/useReveal';

export default function Home() {
  useReveal();

  const scrollToSubscribe = useCallback(() => {
    const target = document.getElementById('subscribe');
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, []);

  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar onOpenSubscribe={scrollToSubscribe} />
      <main className="w-full">
        <Hero />
        <Ticker />
        <RankingSection />
        <CollectionsSection />
        <LatestSection />
        <StatsSection />
        <DigSection />
        <TimelineSection />
        <SubscribeSection />
      </main>
      <Footer onSubscribe={scrollToSubscribe} />
    </div>
  );
}